import { takeEvery, takeLatest, takeLeading } from "redux-saga/effects";
import {
  handleLogInUser,
  handleRegisterUser,
  handleGetCurrentUser,
} from "./handlers/user";
import {
  logInUser,
  getCurrentUser,
  registerUser,
} from "../slices/user/userSlice";
import { addSubscriptionDetail } from "../slices/company/companySlice";
import { handleAddSubscriptionDetail } from "./handlers/company";
import * as productSlice from "../slices/product/productSlice";
import * as productHandler from "./handlers/product";
import * as itemSlice from "../slices/item/itemSlice";
import * as itemHandler from "./handlers/item";
import * as stepSlice from "../slices/step/stepSlice";
import * as stepHandler from "./handlers/step";

export function* watcherSaga() {
  //register user
  yield takeEvery(registerUser.type, handleRegisterUser);
  //authentication/user
  yield takeEvery(logInUser.type, handleLogInUser);
  yield takeEvery(getCurrentUser.type, handleGetCurrentUser);
  //add subscription
  yield takeEvery(addSubscriptionDetail.type, handleAddSubscriptionDetail);
  // Products from here on
  yield takeEvery(
    productSlice.addProduct.type,
    productHandler.handleAddProduct
  );
  yield takeLeading(
    productSlice.editProduct.type,
    productHandler.handleEditProduct
  );
  yield takeLeading(
    productSlice.deleteProduct.type,
    productHandler.handleDeleteProduct
  );
  yield takeEvery(
    productSlice.getAllProducts.type,
    productHandler.handleGetAllProducts
  );
  // Items from here on
  yield takeEvery(itemSlice.addItem.type, itemHandler.handleAddItem);
  yield takeLeading(itemSlice.editItem.type, itemHandler.handleEditItem);
  yield takeLeading(itemSlice.deleteItem.type, itemHandler.handleDeleteItem);
  yield takeEvery(itemSlice.getAllItems.type, itemHandler.handleGetAllItems);
  // Steps from here on
  yield takeLeading(stepSlice.saveSteps.type, stepHandler.handleSaveSteps);
  yield takeLeading(stepSlice.getAllSteps.type, stepHandler.handleGetAllSteps);
}
